import { Record, Map, OrderedMap } from 'immutable';
import create from './create';

const HomeworkContentItemRecord = Record({
  homeworkContentId: undefined,
  name: undefined,
  description: undefined,
  isAssigned: undefined,
  homeworkType: undefined,
  isDeleted: undefined,
});

const HomeworkContentRecord = Record({
  unitId: undefined,
  unitOrderingSequence: undefined,
  lessonNumber: undefined,
  contentItems: new OrderedMap(),
});

class HomeworkContentItem extends HomeworkContentItemRecord { }
class HomeworkContent extends HomeworkContentRecord { }

HomeworkContentItem.create = (data) => {  // lazy reviver
  let newData = new Map(data);
  newData = newData.set('homeworkContentId', `${data.homeworkContentId}`);  // stringify
  return new HomeworkContentItem(newData);
};

HomeworkContent.serialize = (model) =>  // eslint-disable-line no-confusing-arrow
  Array.isArray(model) ? model : model.map((lesson) =>
    lesson.update('contentItems', (contentItems) =>
      contentItems.toArray())
    ).toArray();

HomeworkContent.Item = HomeworkContentItem;
HomeworkContent.create = create;

export default HomeworkContent;



// WEBPACK FOOTER //
// ./data/Homework/Content/model.js